import styled from "styled-components";

export const Wrapper = styled.footer`
 
`;

export const ContentWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  background: white;
`;

export const FooterH = styled.h2`
  padding: 30px 20px;
  font-weight: bold;
  font-family: "poppins", sans-serif;
  font-size: 20px;
  text-align: center;

  @media screen and (max-width:500px){
    font-size: 15px;
  }
`;
